export function formatSizeLabel(size) {
    if (!size || !size.label) {
        return '';
    }
    return size.unit ? `${size.label} ${size.unit}` : size.label;
}

export default formatSizeLabel;
